export default 
{
    meta: {
        'title': 'Replace Something',
        'description': 'Only front-end implementaion of SQL log input parameter replacement, free you from the operation of parameter replacement one by one',
        'keywords': 'SQL,MySql,MyBatis,JDBC'
    },
    main: {
        'param': 'Param',
        'replace': 'Replace',
        'tryIt': 'Try it!',
        'pleaseInput': 'Please Input',
        'result': 'Result',
        'sqlTips': 'Input sql with "?" (e.g., select * from table where a = ? and b = ? and c = ? and d = ?)',
        'paramTips': 'JDBC param with type (e.g., a(String),1(Integer),2020-01-01(Timestamp),8.88(BigDecimal))',
        'successMsg': 'Content has been copied to clipboard.',
        'paramsNotMatch': 'Parameters size not match, please check.',
        'paramsError': 'Parameters may contains illegal charaters, please check.'
    }
}